import createEmployeFormModel from './createEmployeFormModel';
const {
  formField: {
    // DATOS CLIENTE 
    document_type,
    document_number,
    expedition_place,
    file_img_upload,
    name,
    last_name,
    date_of_birth,
    gender,
    civil_status,
    landline,
    cell_phone,
    whatsapp,
    rh,
    dominance,
    allergies,
    cedula,
    housing_type,
    neighborhood,
    stratum,
    cost_center,
    compani,
    work_headquarters,
    cargo,
    cv,
    scholarship,
    institution,
    degree,
    address,
    email,


    // LABORAL 
    type_contract,
    salary_base,
    transport_subsidy,
    payment_method,
    frecuency_payment,
    associated_bank,
    certificate_banck_name_saved_name,
    account_number,
    certificate_bank,
    date_start_contract,
    vacation_acumulate,
    bonification_aditional,
    lunes,
    martes,
    miercoles,
    jueves,
    viernes,
    sabado,
    domingo,
    festivo,
    dayrest,
    // FAMILIA 
    numOfBeneficiary,
    // family,
    // SEGURIDAD SOCIAL 
    eps,
    familyCompensation,
    fileCajaCompensacion,
    caja_compensacion_name_saved,
    cesantias,
    fileCesantias,
    cesantias_name_saved,
    pension,
    fileArl,
    // DOTACION 
    // items_uno,
    // talla_uno,
    // cantidad_uno,
    // color_uno,
    // item_descripcion_uno,
    // items2,
    // talla2,
    // cantidad2,
    // color2,
    // item_descripcion2,
    // items3,
    // talla3,
    // cantidad3,
    // color3,
    // item_descripcion3,
    // items4,
    // talla4,
    // cantidad4,
    // color4,
    // item_descripcion4,
    // items5,
    // talla5,
    // cantidad5,
    // color5,
    // item_descripcion5,
    // PRUEBAS INGRESO 
    vista_domiciliaria,
    fileVisitaDomiciliaria,
    visita_domiciliaria_name_saved,
    prueba_psicotecnica,
    filePsicotecnica,
    psicotecnica_name_saved,
    manipulacion_alimentos,
    fileManipulacionAlimentos,
    manipulacion_alimentos_name_saved,
    trabajo_alturas,
    fileTrabajoAlturas,
    trabajo_altura_name_saved,
    fileExamenMedico,
    examen_medico,
    examen_medico_name_saved,
    contrato,
    certificado_estudios,
    fileCertificadoEstudios,
    certificado_estudios_name_saved,
    certificado_laboral,
    fileCertificadoLaboral,
    certificado_laboral_name_saved,
    verificacion_adres,
    fileVerificacionAdres,
    verificacion_adres_name_saved,
    antecedentes,
    fileAntecedentes,
    antecedentes_name_saved,
    entrevista,
    fileEntrevista,
    entrevista_name_saved,
    sociodemografica,
    fileSociodemografica,
    sociodemografica_name_saved,

    encuesta_dme,
    fileEncuestaDme,
    encuesta_dme_name_saved,

    compromiso_sst,
    fileCompromisoSst,
    compromiso_sst_name_saved,


  } 
} = createEmployeFormModel;

// Calcular la fecha de hoy menos 18 años
const today = new Date();
const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

export default {
  [document_type.name]: '',
  [document_number.name]: '',
  [expedition_place.name]: '',
  [file_img_upload.name]: null,
  [name.name]: '', 
  [last_name.name]: '',
  [date_of_birth.name]: eighteenYearsAgo,
  [gender.name]: null, 
  [civil_status.name]: null,
  [landline.name]: '',
  [cell_phone.name]: '',
  [whatsapp.name]: false,
  [rh.name]: '',
  [dominance.name]: '',
  [allergies.name]: '',
  [cedula.name]: null,
  [housing_type.name]: null,
  [neighborhood.name]: '',
  [stratum.name]: '',
  [cost_center.name]: null,
  [compani.name]: '',
  [work_headquarters.name]: null,
  [cargo.name]: null,
  [cv.name]: null,
  [scholarship.name]: null,
  [institution.name]: '',
  [degree.name]: '',
  [address.name]: '',
  [email.name]: '',


  // LABORAL 
  [type_contract.name]: '',
  [salary_base.name]: '',
  [transport_subsidy.name]: false,
  [payment_method.name]: '',
  [frecuency_payment.name]: '',
  [associated_bank.name]: '',
  [certificate_banck_name_saved_name.name]: '',
  [account_number.name]: '',  
  [certificate_bank.name]: null,
  [vacation_acumulate.name]: '',
  [bonification_aditional.name]: '',
  [date_start_contract.name]: null,
  [lunes.name]: false,
  [martes.name]: false,
  [miercoles.name]: false,
  [jueves.name]: false,
  [viernes.name]: false,
  [sabado.name]: false,
  [domingo.name]: false,
  [festivo.name]: false,
  [dayrest.name]: '',


  // FAMILIA 
  [numOfBeneficiary.name]: 0,
  // [family.name]: '',
  
  
  
  // SEGURIDAD SOCIAL 
  [eps.name]: null,
  [familyCompensation.name]: null,
  [fileCajaCompensacion.name]: null,
  [caja_compensacion_name_saved.name]: null,
  [cesantias.name]: null,
  [cesantias_name_saved.name]: null, 
  [fileCesantias.name]: null,
  [pension.name]: null,
  [fileArl.name]: null,
  // DOTACION 
  // [items_uno.name]: null,
  // [talla_uno.name]: '',
  // [cantidad_uno.name]: '',
  // [color_uno.name]: '',
  // [item_descripcion_uno.name]: '',
  // [items2.name]: null,
  // [talla2.name]: '',
  // [cantidad2.name]: '',
  // [color2.name]: '',
  // [item_descripcion2.name]: '',
  // [items3.name]: null,
  // [talla3.name]: '',
  // [cantidad3.name]: '',
  // [color3.name]: '',
  // [item_descripcion3.name]: '',
  // [items4.name]: null,
  // [talla4.name]: '',
  // [cantidad4.name]: '',
  // [color4.name]: '',
  // [item_descripcion4.name]: '',
  // [items5.name]: null,
  // [talla5.name]: '',
  // [cantidad5.name]: '',
  // [color5.name]: '',
  // [item_descripcion5.name]: '',
  // PRUEBAS INGRESO 
  [vista_domiciliaria.name]: false,
  [fileVisitaDomiciliaria.name]: null,
  [visita_domiciliaria_name_saved.name]: '',
  // VISITA DOMICILIARIA 
  [prueba_psicotecnica.name]: false,
  [filePsicotecnica.name]: null,
  [psicotecnica_name_saved.name]: '',
  // MANIPULACION ALIMENTOS 
  [manipulacion_alimentos.name]: false,
  [fileManipulacionAlimentos.name]: null,
  [manipulacion_alimentos_name_saved.name]: '',
  // TRABAJO EN ALTURAS 
  [trabajo_alturas.name]: false,
  [fileTrabajoAlturas.name]: null,
  [trabajo_altura_name_saved.name]: '',
  // EXAMEN MEDICO 
  [examen_medico.name]: false,
  [fileExamenMedico.name]: null,
  [examen_medico_name_saved.name]: '',
  // CONTRATO 
  [contrato.name]: false,
  // CERTIFICADO ESTUDIOS
  [certificado_estudios.name]: false,
  [fileCertificadoEstudios.name]: null,
  [certificado_estudios_name_saved.name]: '',
  // CERTIFICADO LABORAL
  [certificado_laboral.name]: false,
  [fileCertificadoLaboral.name]: null,
  [certificado_laboral_name_saved.name]: '',
  // VERIFICACION ADRES  
  [verificacion_adres.name]: false,
  [fileVerificacionAdres.name]: null,
  [verificacion_adres_name_saved.name]: '',
  // ANTECEDENTES 
  [antecedentes.name]: false,
  [fileAntecedentes.name]: null,
  [antecedentes_name_saved.name]: '',
  // ENTREVISTA 
  [entrevista.name]: false,
  [fileEntrevista.name]: null,
  [entrevista_name_saved.name]: '',
  // ENTREVISTA SOCIODEMOGRAFICA 
  [sociodemografica.name]: false,
  [fileSociodemografica.name]: null,
  [sociodemografica_name_saved.name]: '',
  // ENTREVISTA SOCIODEMOGRAFICA 
  [encuesta_dme.name]: false,
  [fileEncuestaDme.name]: null,
  [encuesta_dme_name_saved.name]: '',
  // COMPROMISO SST 
  [compromiso_sst.name]: false,
  [fileCompromisoSst.name]: null,
  [compromiso_sst_name_saved.name]: '',
};   

